(function () {
    'use strict';
    var controllerId = 'schedaCompetenzeSessionDetail';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'common', 'schedaCompetenzeSessionDetail', 'allievo','readonly', schedaCompetenzeSessionDetailFn]);

    function schedaCompetenzeSessionDetailFn($scope, $uibModalInstance, datacontext, common, schedaCompetenzeSessionDetail, allievo, readonly) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        
        if (readonly == true) {
            $scope.readonly = 1;
        }
        else
            $scope.readonly = 0;
        $scope.schedaCompetenzeSessionDetail = schedaCompetenzeSessionDetail;
        $scope.Titolo = 'SchedaCompetenze';
        $scope.Allievo = allievo.studente;
        $scope.item = {};
        $scope.item.ricalcolo = false;
        $scope.item.LetteraDefault = "";
        $scope.item.ValutazioneDefault = "";
        calcolaLetteraDefault();
            
        function calcolaLetteraDefault() {
            datacontext.valutazioneDoc_getByVoto($scope.schedaCompetenzeSessionDetail.Voto).then(function (data) {
                if (data) {
                    $scope.item.LetteraDefault = data.Lettera;
                }                    
            });
        };
       

        $scope.ok = function (isValid) {
            if (isValid) {
                $scope.schedaCompetenzeSessionDetail.Lettera = $scope.schedaCompetenzeSessionDetail.Lettera.toUpperCase();
                if ($scope.item.LetteraDefault == $scope.schedaCompetenzeSessionDetail.Lettera)
                    $scope.schedaCompetenzeSessionDetail.LetteraModificata = false;
                else
                    $scope.schedaCompetenzeSessionDetail.LetteraModificata = true;

                $uibModalInstance.close($scope.schedaCompetenzeSessionDetail);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };          

        $scope.ricalcolaVoto = function () {
            $scope.item.ricalcolo = true;

            datacontext.valutazioneDoc_getByVoto($scope.schedaCompetenzeSessionDetail.Voto).then(function (data) {
                if (data) {
                    $scope.schedaCompetenzeSessionDetail.Lettera = data.Lettera;
                    $scope.schedaCompetenzeSessionDetail.Personalizzazione2 = data.Valutazione;
                }                    
            });
        };

        $scope.getValutazione = function () {
            if ($scope.item.ricalcolo)
                return;

            datacontext.valutazioneDoc_getByLettera($scope.schedaCompetenzeSessionDetail.Lettera).then(function (data) {                
                if (data)
                    $scope.schedaCompetenzeSessionDetail.Personalizzazione2 = data.Valutazione;
            });
        };
    }
})();